import { connect } from "react-redux";
import { callMeBackTrigger } from "../reducers/callMeBack";
import { Root } from "../screens/Root";
import { offerGetFromApi } from "../reducers/offer";
import { getUserFromOtp } from "../reducers/otp";
import { personalDataSetAnalytics, personalDataSetReferrer } from "../reducers/personalDataForm";
import { checkDisplayCallMeButtons } from "../reducers/globalFormFields";
import { blockingPopupSet } from "../reducers/blockingPopup";
import { textsReducerGetTexts } from "../reducers/textsReducer";
import { pdrPodBlockPopupSetIsOpen, PDR_POD_BLOCK_CATEGORIES } from "../reducers/pdrPodBlockPopupTimeGate";
import { ERROR_TEXTS } from "../utils/constants";
import { unloadListenerFunction } from "../utils/unloadListenerFunction";
import { changeOfferTypeSetPopupOpen, changeOfferResetState } from "../reducers/changeOfferType";

function mapStateToProps(state) {
    const { callMeBackReducer, blockingPopupReducer, pdrPodBlockPopupTimeGateReducer } = state;
    let popupTimeGateErrorMessage = ERROR_TEXTS.podTimeGateError;
    if (pdrPodBlockPopupTimeGateReducer.category === PDR_POD_BLOCK_CATEGORIES.PDR) {
        popupTimeGateErrorMessage = ERROR_TEXTS.pdrTimeGateError;
    }

    return {
        callMeBackReducer,
        isCallMeVisibile: callMeBackReducer.isVisible,
        popup: blockingPopupReducer,
        isPopupTimeGateOpen: pdrPodBlockPopupTimeGateReducer.isOpen,
        popupTimeGateErrorMessage,
        offer: state.offer,

        isChangeOfferTypePopupOpen: state.changeOfferTypeState.isPopupOpen,
        isCouponInvalid: state.offer.isCouponInvalid,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleCallMeBack: isVisible => dispatch(callMeBackTrigger({ isVisible })),
        getOffer: ({
            offerId, coupon, offerType, shouldShowPopupSelectedType
        }) => dispatch(offerGetFromApi({offerId, offerType, shouldShowPopupSelectedType, coupon })),
        getUserFromOtp: (otp, history) => dispatch(getUserFromOtp(otp, history)),
        setAnalytics: analytics => dispatch(personalDataSetAnalytics(analytics)),
        setReferrer: referrer => dispatch(personalDataSetReferrer(referrer)),
        checkDisplayCallMeButtons: () => dispatch(checkDisplayCallMeButtons()),
        closePopup: () => {
            dispatch(blockingPopupSet(false, ''));
            window.removeEventListener('beforeunload', unloadListenerFunction);
            window.location = "https://www.vivigas.it/prodotti/";
        },
        getTexts: () => dispatch(textsReducerGetTexts()),
        closePodPdrTimeGatePopup: () => {
            dispatch(pdrPodBlockPopupSetIsOpen(false, null));
            window.removeEventListener('beforeunload', unloadListenerFunction);
            window.location = "https://www.vivigas.it/";
        },
        resetChangeOfferPopup: () => dispatch(changeOfferResetState()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Root);